import { type PropsWithChildren } from 'react'
import { useSpacingToken } from '../../theme/hooks/use-spacing-token'
import { Box } from '../../primitives/Box'

export type AccordionContentProps = PropsWithChildren<{
  noPaddings?: boolean
  noPaddingSides?: boolean
  noPaddingTop?: boolean
  noPaddingBottom?: boolean
}>

const getStyles = (
  { noPaddings, noPaddingSides, noPaddingTop, noPaddingBottom }: AccordionContentProps,
  spacingToken: number
) => {
  if (noPaddings || (noPaddingSides && noPaddingTop && noPaddingBottom)) {
    return {
      flex: '1',
      minHeight: 0,
    }
  }

  const px = spacingToken
  const pt = noPaddingTop ? 0 : 2
  const pb = noPaddingBottom ? 0 : 2

  return { flex: '1', minHeight: 0, px: noPaddingSides ? 0 : px, pt, pb }
}

export const AccordionContent = ({ children, ...rest }: AccordionContentProps) => {
  const spacingToken = useSpacingToken()
  const sx = getStyles(rest, spacingToken)

  return <Box sx={sx}>{children}</Box>
}
